"use client";

import React from "react";
// import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import Image from "@components/common/Image";
import styles from "./Banner.module.scss";
import { get } from "lodash";
import cx from "classnames";
const BANNER = {
  title: <h1>Phương Võ</h1>,
  description: `Frontend Developer`,
};

const View = () => {
  return (
    <section data-scroll-section className={styles.section}>
      <div className={styles.avatar}>
        <Image
          src="/author.jpg"
          scale="1.1"
          speed={-0.3}
          wrapperProps={{ className: styles.image }}
        />
      </div>
      <div className={styles.title}>{get(BANNER, "title")}</div>
      <p className={cx(styles.description, "text-gradient-cotton-candy")}>
        {get(BANNER, "description")}
      </p>
    </section>
  );
};
export default View;
